import { combineReducers } from 'redux';

import backendHealthReducer from './ducks/backend';

const reducers = {
  backend: backendHealthReducer,
};

export default combineReducers(reducers);
